export default {
  feedback: {
    token_required: 'Zaznacz pole, aby potwierdzić, że jesteś człowiekiem',
    frequent_requests:
      'Sprawdź SMS. Kod został już wysłany na podany numer. Jeśli nie dotarł, sprawdź numer telefonu lub spróbuj ponownie za 10 minut.',
  },
};
